import { render } from "./AboutView.vue?vue&type=template&id=e79c9b7e&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=e79c9b7e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79c9b7e"]])

export default __exports__